import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusFilterComponent } from './status-filter.component';
import { JamFilterModule } from 'ngx-jsonapi-material';

@NgModule({
    declarations: [StatusFilterComponent],
    exports: [StatusFilterComponent],
    imports: [CommonModule, JamFilterModule]
})
export class StatusFilterModule {}
